import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import UploadIcon from "../../Assets/svgs/uploadIcon.svg";
import "./style.css";
import { toast } from "react-toastify";
import {
  BASEURL,
  GetCookie,
  LoadingSpinner,
  axios,
} from "../../Libraries/Media";
import { useCallback } from "react";
import PropTypes from "prop-types";
import { CONTENT_BASEURL, MAX_UPLOAD_FILE_SIZE } from "../../Utils/Constants/constants";

const Dropzone = ({ handleIndexChange, getAllMediaFunc }) => {
  const [totalprogress, settotalprogress] = useState(0);
  const [isloading, setisloading] = useState(false);

  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    settotalprogress(percentCompleted);
    if (percentCompleted === 100) {
      setTimeout(() => {
        settotalprogress(0);
      }, 400);
    }
  };
  //multiple at a time
  // const onDrop = useCallback(
  //   async (acceptedFiles) => {
  //     if (acceptedFiles.length > 0) {
  //       setisloading(true); 
  
  //       const uploadPromises = acceptedFiles.map(async (file) => {
  //         if (file.size >= MAX_UPLOAD_FILE_SIZE) {
  //           toast.info(`Max file upload size is 900Mb for ${file.name}`);
  //           return; 
  //         }
  
  //         const mediadata = new FormData();
  //         mediadata.append(
  //           "txt_customer_id",
  //           localStorage.getItem("txt_customer_id")
  //         );
  //         mediadata.append("security_token", await GetCookie("es_token"));
  //         mediadata.append("upload_type", "File");
  //         mediadata.append("myFile", file); 
  
  //         try {
  //           const returned = await axios.post(
  //             CONTENT_BASEURL + "boostboard-content/addMedia.php",
  //             mediadata,
  //             { onUploadProgress }
  //           );
  
  //           if (
  //             returned.data.status === "true" &&
  //             returned.data.connection === "true" &&
  //             returned.data.message === "File uploaded successfully"
  //           ) {
  //             toast.success(`File: ${file.name} uploaded successfully`);
  //             getAllMediaFunc();
              
  //             if (file.type !== "video/mp4") {
  //               handleIndexChange(0);
  //             } else {
  //               handleIndexChange(1);
  //             }
  //           } else {
  //             toast.error(returned.data.message);
  //           }
  //         } catch (error) {
  //           console.error(`Error uploading file: ${file.name}`, error);
  //           toast.error(`Error uploading file: ${file.name}`);
  //         }
  //       });
  
  //       await Promise.all(uploadPromises);
  
  //       setisloading(false); 
  //     } else {
  //       toast.error("No Files Selected");
  //       setisloading(false);
  //     }
  //   },
  //   [getAllMediaFunc, handleIndexChange]
  // );
  //parallel one by one
  // const onDrop = useCallback(
  //   async (acceptedFiles) => {
  //     if (acceptedFiles.length > 0) {
  //       for (const file of acceptedFiles) {
  //         if (file.size >= MAX_UPLOAD_FILE_SIZE) {
  //           toast.info("Max file upload size is 900Mb");
  //         } else {
  //           setisloading(true);
  //           const mediadata = new FormData();
  //           mediadata.append(
  //             "txt_customer_id",
  //             localStorage.getItem("txt_customer_id")
  //           );
  //           mediadata.append("security_token", await GetCookie("es_token"));
  //           mediadata.append("upload_type", "File");
  //           mediadata.append("myFile", file); 
  
  //           try {
  //             const returned = await axios.post(
  //               CONTENT_BASEURL + "boostboard-content/addMedia.php",
  //               mediadata,
  //               { onUploadProgress }
  //             );
  //             if (
  //               returned.data.status === "true" &&
  //               returned.data.connection === "true" &&
  //               returned.data.message === "File uploaded successfully"
  //             ) {
  //               toast.success(`File: ${file.name} uploaded successfully`);
  //               getAllMediaFunc();
  //               if (file.type !== "video/mp4") {
  //                 handleIndexChange(0);
  //               } else {
  //                 handleIndexChange(1);
  //               }
  //             } else {
  //               toast.error(returned.data.message);
  //             }
  //           } catch (error) {
  //             console.error(error);
  //             toast.error(`Error uploading file: ${file.name}`);
  //           }
  //         }
  //       }
  //       setisloading(false);
  //     } else {
  //       toast.error("No Files Selected");
  //       setisloading(false);
  //     }
  //   },
  //   [getAllMediaFunc, handleIndexChange]
  // );
  
  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (acceptedFiles) {
        if (acceptedFiles[0].size >= MAX_UPLOAD_FILE_SIZE) {
          toast.info("Max file upload size is 900Mb");
        } else {
          setisloading(true);
          const mediadata = new FormData();
          mediadata.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          mediadata.append("security_token", await GetCookie("es_token"));
          mediadata.append("upload_type", "File");
          mediadata.append("myFile", acceptedFiles[0]);
          try {
            const returned = await axios.post(
              CONTENT_BASEURL + "boostboard-content/addMedia.php",
              mediadata,
              { onUploadProgress }
            );
            if (
              returned.data.status === "true" &&
              returned.data.connection === "true" &&
              returned.data.message === "File uploaded successfully"
            ) {
              setisloading(false);
              toast.success(returned.data.message);
              getAllMediaFunc();
              if (acceptedFiles[0].type !== "video/mp4") {
                handleIndexChange(0);
              } else {
                handleIndexChange(1);
              }
            } else {
              toast.error(returned.data.message);
              setisloading(false);
            }
          } catch (error) {
            console.error(error);
            setisloading(false);
          }
        }
      } else {
        toast.error("No File Selected");
        setisloading(false);
      }
    },
    [getAllMediaFunc, handleIndexChange]
  );


  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    // multiple: true,
    multiple: false,
    onDrop,
  });

  return (
    <Box>
      {isloading ? <LoadingSpinner totalprogress={totalprogress} /> : null}

      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <img src={UploadIcon} alt="icon" />
        <p>Drag and drop file here</p>
        <p>OR</p>
        <Button type="button" variant="contained" onClick={open} className="capitalized fs-14 fw-bold">
          Browse file
        </Button>
      </div>
    </Box>
  );
};

Dropzone.propTypes = {
  handleIndexChange: PropTypes.func,
  getAllMediaFunc: PropTypes.func,
};

export default Dropzone;
